// admin/LGADashboard.js
import React from 'react';

const LGADashboard = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>LGA Administration Dashboard</h1>
      <p>Welcome to LGA Admin Dashboard - Local Government Area management</p>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px', marginTop: '20px' }}>
        <div style={{ background: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <h3>LGA Statistics</h3>
          <p>Total Members: 3,245</p>
        </div>
      </div>
    </div>
  );
};

export default LGADashboard;